import { render, staticRenderFns } from "./AdminNav.vue?vue&type=template&id=b9e89e56&scoped=true&"
import script from "./AdminNav.vue?vue&type=script&lang=js&"
export * from "./AdminNav.vue?vue&type=script&lang=js&"
import style0 from "./AdminNav.vue?vue&type=style&index=0&id=b9e89e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e89e56",
  null
  
)

export default component.exports